var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alerttop",attrs:{"border":"bottom","colored-border":"","icon":"fas fa-exclamation-triangle","elevation":"2"}},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.content5))]),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.content6)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }